// import { createSlice } from '@reduxjs/toolkit'
// import {  auth, database } from 'utils/firebase'
//
// // ------------------------------------
// // State
// // ------------------------------------
//
// const initialState = {
//   checked: false,
//   loggedIn: false,
//   me: {},
// }
//
// // ------------------------------------
// // Slices
// // -----------------------------------
//
// const slice = createSlice({
//   name: 'app',
//   initialState,
//   reducers: {
//     setMe: (state, action) => ({
//       ...state,
//       me: action.payload.me,
//       loggedIn: action.payload.loggedIn,
//       checked: true,
//     }),
//     setLoggedIn: (state, action) => ({
//       ...state,
//       loggedIn: action.payload,
//     }),
//   },
// })
//
// // ------------------------------------
// // Actions
// // -----------------------------------
//
// export const authenticate = () => (dispatch) => {
//   auth.onAuthStateChanged(async (me) => {
//     if (!me) {
//       return dispatch(
//         slice.actions.setMe({
//           loggedIn: false,
//           checked: true,
//           me: {},
//         }),
//       )
//     }
//
//     // get user from firestore
//     // const user = await firestore.collection('users').doc(me?.uid).get()
//
//     // login
//     // return dispatch(
//     //   slice.actions.setMe({
//     //     loggedIn: me?.emailVerified && user.exists,
//     //     me: user.exists
//     //       ? { id: me?.uid, emailVerified: me?.emailVerified, ...user.data() }
//     //       : {},
//     //     checked: true,
//     //   }),
//     // )
//
//
//
//   })
// }
//
// const signup = ({ fullName, email, password }) => () =>
//   new Promise(async (resolve, reject) => {
//     try {
//       // create user
//       const { user } = await auth.createUserWithEmailAndPassword(
//         email,
//         password,
//       )
//
//       // send confirmation email
//       await user.sendEmailVerification()
//
//       // store user info in firestore
//       await firestore.collection('users').doc(user.uid).set({
//         fullName,
//         email,
//       })
//
//       resolve(user)
//     } catch (err) {
//       reject(err)
//     }
//   })
//
// const login = ({ email, password }) => (dispatch) =>
//   new Promise(async (resolve, reject) => {
//     try {
//       const { user } = await auth.signInWithEmailAndPassword(email, password)
//       if (!user) reject(new Error('Failed to login. please try it again later'))
//       if (!user.emailVerified) await user.sendEmailVerification()
//       dispatch(authenticate())
//       resolve(user)
//     } catch (err) {
//       reject(err)
//     }
//   })
//
// const logout = () => (dispatch) =>
//   new Promise(async (resolve, reject) => {
//     try {
//       await auth.signOut()
//       dispatch(
//         slice.actions.setMe({
//           checked: true,
//           loggedIn: false,
//           me: {},
//         }),
//       )
//       resolve()
//     } catch (err) {
//       reject(err)
//     }
//   })
//
// const resetPassword = (email) => () => auth.sendPasswordResetEmail(email)
//
// // ------------------------------------
// // Exports
// // ------------------------------------
//
// export const actions = {
//   ...slice.actions,
//   authenticate,
//   signup,
//   login,
//   logout,
//   resetPassword,
// }
//
// export default slice.reducer

import { createSlice } from '@reduxjs/toolkit'
import { auth, database } from 'utils/firebase'

// ------------------------------------
// State
// ------------------------------------

const initialState = {
  checked: false,
  loggedIn: false,
  me: {},
  pastConsultationDateRange: null,
}

// ------------------------------------
// Slices
// -----------------------------------

const slice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setMe: (state, action) => ({
      ...state,
      me: action.payload.me,
      loggedIn: action.payload.loggedIn,
      checked: true,
    }),
    setLoggedIn: (state, action) => ({
      ...state,
      loggedIn: action.payload,
    }),
    setPastConsultationDateRange: (state, action) => ({
      ...state,
      pastConsultationDateRange: {
        range: action.payload.range,
        storedAt: action.payload.storedAt ?? Date.now(),
      },
    }),
    clearPastConsultationDateRange: (state) => ({
      ...state,
      pastConsultationDateRange: null,
    }),
  },
})

// ------------------------------------
// Actions
// -----------------------------------

export const authenticate = () => (dispatch) => {
  // eslint-disable-next-line consistent-return
  auth.onAuthStateChanged(async (me) => {
    if (!me) {
      return dispatch(
        slice.actions.setMe({
          loggedIn: false,
          checked: true,
          me: {},
        }),
      )
    }

    // eslint-disable-next-line consistent-return
    /* me.getIdTokenResult().then(async (idTokenResult) => {
      // console.log(idTokenResult)
      if (!(idTokenResult.claims.admin || idTokenResult.claims.doctor)) {
        await auth.signOut()
        // eslint-disable-next-line no-undef
        alert('You are not authorized!')
        return dispatch(
          slice.actions.setMe({
            loggedIn: false,
            checked: true,
            me: {},
          }),
        )
      }
    }) */

    // get user from firestore
    await database.ref(`doctors/${me?.uid}`).on('value', async (userSnap) => {
      const user = userSnap.exists() ? userSnap.toJSON() : {}
      if (userSnap.exists() && user?.profileStatus !== 'deleted') {
        dispatch(
          slice.actions.setMe({
            loggedIn: userSnap.exists(),
            me: userSnap.exists() ? { id: me?.uid, ...user } : {},
            checked: true,
          }),
        )
      } else {
        await auth.signOut()
        // eslint-disable-next-line no-undef
        alert('You are not authorized!')

        dispatch(
          slice.actions.setMe({
            loggedIn: false,
            checked: true,
            me: {},
          }),
        )
      }
    })

    // login
  })
}

const signup =
  ({ fullName, email, password }) =>
  () =>
    new Promise(async (resolve, reject) => {
      try {
        // create user
        const { user } = await auth.createUserWithEmailAndPassword(
          email,
          password,
        )

        // send confirmation email
        await user.sendEmailVerification()

        // store user info in firestore
        // await firestore.collection('users').doc(user.uid).set({
        //   fullName,
        //   email,
        // })

        resolve(user)
      } catch (err) {
        reject(err)
      }
    })

const login = ({ email, password }) => (dispatch) =>
    new Promise(async (resolve, reject) => {
      try {
        const { user } = await auth.signInWithEmailAndPassword(email, password)
        if (!user)
          reject(new Error('Failed to login. please try it again later'))
        // if (!user.emailVerified) await user.sendEmailVerification()
        dispatch(authenticate())
        resolve(user)
      } catch (err) {
        reject(err)
      }
    })

const logout = () => (dispatch) =>
  new Promise(async (resolve, reject) => {
    try {
      await auth.signOut()
      dispatch(
        slice.actions.setMe({
          checked: true,
          loggedIn: false,
          me: {},
        }),
      )
      resolve()
    } catch (err) {
      reject(err)
    }
  })

const resetPassword = (email) => () => auth.sendPasswordResetEmail(email)

// ------------------------------------
// Exports
// ------------------------------------

export const actions = {
  ...slice.actions,
  authenticate,
  signup,
  login,
  logout,
  resetPassword,
}

export default slice.reducer
